// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate, Link } from "react-router-dom";
// import Layout, { Container } from "../components/layout";
// import axios from "axios";
// import { apiurl } from "../config/config";
// import { SuwasthiLoader } from "../components/loader";
// import Breadcrumb from "../components/breadcrumb";

// const ApplicationDetails = () => {
//   const { applicationObjId } = useParams();
//   const navigate = useNavigate();
//   const [application, setApplication] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [documentLink, setDocumentLink] = useState("");

//   useEffect(() => {
//     axios
//       .get(`${apiurl}/api/application/get/${applicationObjId}`)
//       .then((res) => {
//         setApplication(res?.data?.application);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error fetching application:", error);
//         setLoading(false);
//       });
//   }, [applicationObjId]);

//   const openModal = (link) => {
//     setDocumentLink(link);
//     setShowModal(true);
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     setDocumentLink("");
//   };

//   if (loading) {
//     return (
//       <Layout>
//         <SuwasthiLoader />
//       </Layout>
//     );
//   }

//   if (!application) {
//     return (
//       <Layout>
//         <div className="text-center text-red-500 font-semibold mt-10">
//           Application not found.
//         </div>
//       </Layout>
//     );
//   }

//   return (
//     <Layout>
//       <Breadcrumb page="View Application" />
//       <Container overflow={"overflow-scroll"}>
//         <div className="p-2 bg-gray-50 min-h-screen flex flex-col items-center">
//           <div className="bg-white border rounded-xl p-6 w-full">
//             <div className="grid grid-cols-2 gap-4">
//               <p>
//                 <strong>Application ID:</strong> {application?.id}
//               </p>
//               <p>
//                 <strong>Aadhar Number:</strong>{" "}
//                 {application?.candidateSnapshot?.aadharNumber}
//               </p>
//               <p>
//                 <strong>Name:</strong>{" "}
//                 {application?.candidateSnapshot?.firstName}{" "}
//                 {application?.candidateSnapshot?.lastName}
//               </p>
//               <p>
//                 <strong>Email:</strong> {application?.candidateSnapshot?.email}
//               </p>
//               <p>
//                 <strong>Phone:</strong> {application?.candidateSnapshot?.phone}
//               </p>
//               <p>
//                 <strong>Position:</strong> {application?.positionTitle}
//               </p>
//               <p>
//                 <strong>Department:</strong> {application?.department}
//               </p>
//               <p>
//                 <strong>Status:</strong>{" "}
//                 <span className="text-blue-600">
//                   {application?.applicationStatus}
//                 </span>
//               </p>
//             </div>

//             <div className="mt-6 flex gap-4">
//               {application?.documents?.resume?.link && (
//                 <button
//                   onClick={() => openModal(application.documents.resume.link)}
//                   className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 shadow"
//                 >
//                   View Resume
//                 </button>
//               )}
//               {application?.documents?.aadharCard?.link && (
//                 <button
//                   onClick={() =>
//                     openModal(application.documents.aadharCard.link)
//                   }
//                   className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 shadow"
//                 >
//                   View Aadhar Card
//                 </button>
//               )}
//             </div>
//           </div>

//           {application?.screeningDetails?.status ? (
//             <>
//               <div
//                 className={`w-full border p-4 rounded-lg my-4 ${
//                   application?.screeningDetails?.status === "pass"
//                     ? "border-green-500 text-green-800 bg-green-50"
//                     : application?.screeningDetails?.status === "fail"
//                     ? "border-red-500 text-red-800 bg-red-50"
//                     : "border-gray-500 text-gray-800 bg-gray-100"
//                 }`}
//               >
//                 <p>
//                   <strong>Name:</strong>{" "}
//                   {application?.screeningDetails?.screenerName}
//                 </p>
//                 <p>
//                   <strong>ID:</strong>{" "}
//                   {application?.screeningDetails?.screenerId}
//                 </p>
//                 <p>
//                   <strong>Status:</strong>{" "}
//                   {application?.screeningDetails?.status === "pass"
//                     ? "Approved"
//                     : application?.screeningDetails?.status === "fail"
//                     ? "Rejected"
//                     : "Pending"}
//                 </p>
//                 <p>
//                   <strong>Feedback:</strong>{" "}
//                   {application?.screeningDetails?.feedback}
//                 </p>
//                 <p>
//                   <strong>Date:</strong> {application?.screeningDetails?.date}
//                 </p>
//               </div>
//             </>
//           ) : (
//             <>
//               <div className="w-full border p-4 rounded-lg my-4 border-gray-500 text-gray-800 bg-gray-100">
//                 {" "}
//                 Screener is not assigned yet
//               </div>
//             </>
//           )}
//           {showModal && (
//             <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-80 backdrop-blur-sm">
//               <div className="bg-white rounded-lg shadow-lg p-6 max-w-3xl w-full">
//                 <h2 className="text-xl font-semibold mb-4">Document Preview</h2>

//                 {documentLink.endsWith(".pdf") ? (
//                   <iframe
//                     src={documentLink}
//                     className="w-full h-[500px] rounded-lg"
//                     title="PDF Preview"
//                   />
//                 ) : documentLink.endsWith(".docx") ||
//                   documentLink.endsWith(".xlsx") ? (
//                   <iframe
//                     src={`https://docs.google.com/gview?url=${documentLink}&embedded=true`}
//                     className="w-full h-[500px] rounded-lg"
//                     title="Google Docs Viewer"
//                   />
//                 ) : (
//                   <img
//                     src={documentLink}
//                     alt="Document Preview"
//                     className="w-full max-h-[500px] object-contain rounded-lg"
//                   />
//                 )}

//                 <div className="mt-6 flex justify-end gap-4">
//                   <a
//                     href={documentLink}
//                     target="_blank"
//                     download
//                     className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 shadow"
//                   >
//                     Download
//                   </a>
//                   <button
//                     onClick={closeModal}
//                     className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 shadow"
//                   >
//                     Close
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </Container>
//     </Layout>
//   );
// };

// export default ApplicationDetails;
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout, { Container } from "../components/layout";
import axios from "axios";
import { apiurl } from "../config/config";
import { SuwasthiLoader } from "../components/loader";
import Breadcrumb from "../components/breadcrumb";

const ApplicationDetails = () => {
  const { applicationObjId } = useParams();
  const navigate = useNavigate();
  const [application, setApplication] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [documentLink, setDocumentLink] = useState("");

  useEffect(() => {
    axios
      .get(`${apiurl}/api/application/get/${applicationObjId}`)
      .then((res) => {
        setApplication(res?.data?.application);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching application:", error);
        setLoading(false);
      });
  }, [applicationObjId]);

  const openModal = (link) => {
    setDocumentLink(link);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setDocumentLink("");
  };

  const Card = ({ title, children }) => (
    <div className="bg-white border rounded-xl p-4 shadow-sm w-full">
      <h2 className="text-lg font-semibold border-b pb-2 mb-3">{title}</h2>
      {children}
    </div>
  );

  if (loading) {
    return (
      <Layout>
        <SuwasthiLoader />
      </Layout>
    );
  }

  if (!application) {
    return (
      <Layout>
        <div className="text-center text-red-500 font-semibold mt-10">
          Application not found.
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <Breadcrumb page="View Application" />
      <Container overflow="overflow-scroll">
        <div className="p-2 bg-gray-50 min-h-screen flex flex-col gap-4 mb-10 pb-10">

          {/* Candidate Info */}
          <Card title="Candidate Information">
            <div className="grid grid-cols-2 gap-4">
              <p><strong>Name:</strong> {application?.candidateSnapshot?.firstName} {application?.candidateSnapshot?.lastName}</p>
              <p><strong>Email:</strong> {application?.candidateSnapshot?.email}</p>
              <p><strong>Phone:</strong> {application?.candidateSnapshot?.phone}</p>
              <p><strong>Aadhar:</strong> {application?.candidateSnapshot?.aadharNumber}</p>
              <p><strong>Gender:</strong> {application?.candidateSnapshot?.gender}</p>
              <p><strong>DOB:</strong> {application?.candidateSnapshot?.dateOfBirth}</p>
            </div>
          </Card>

          {/* Job Details */}
          <Card title="Job Details">
            <div className="grid grid-cols-2 gap-4">
              <p><strong>Application ID:</strong> {application?.id}</p>
              <p><strong>Position:</strong> {application?.positionTitle}</p>
              <p><strong>Department:</strong> {application?.department}</p>
              <p><strong>Status:</strong> {application?.applicationStatus}</p>
              <p><strong>Interview Status:</strong> {application?.interviewStatus}</p>
              <p><strong>Applied Date:</strong> {new Date(application?.appliedDate?.$date).toLocaleDateString()}</p>
            </div>
          </Card>

          {/* Screening Details */}
          <Card title="Screening Details">
            {application?.screeningDetails?.status ? (
              <div
                className={`p-4 rounded-lg ${
                  application?.screeningDetails?.status === "pass"
                    ? "bg-green-50 border-green-500 text-green-800"
                    : application?.screeningDetails?.status === "fail"
                    ? "bg-red-50 border-red-500 text-red-800"
                    : "bg-gray-100 border-gray-500 text-gray-800"
                }`}
              >
                <p><strong>Screener Name:</strong> {application?.screeningDetails?.screenerName}</p>
                <p><strong>Screener ID:</strong> {application?.screeningDetails?.screenerId}</p>
                <p><strong>Status:</strong> {application?.screeningDetails?.status === "pass" ? "Approved" : application?.screeningDetails?.status === "fail" ? "Rejected" : "Pending"}</p>
                <p><strong>Feedback:</strong> {application?.screeningDetails?.feedback}</p>
                <p><strong>Date:</strong> {new Date(application?.screeningDetails?.date?.$date).toLocaleString()}</p>
              </div>
            ) : (
              <p>Screener not assigned yet</p>
            )}
          </Card>

          {/* Training Details */}
          {application?.trainingDetails && (
            <Card title="Training Details">
              <div className="grid grid-cols-2 gap-4">
                <p><strong>Trainer Name:</strong> {application.trainingDetails.trainerName}</p>
                <p><strong>Trainer ID:</strong> {application.trainingDetails.trainerId}</p>
                <p><strong>Status:</strong> {application.trainingDetails.status}</p>
              </div>
            </Card>
          )}

          {/* Reference Details */}
          {application?.referenceDetails && (
            <Card title="Reference Details">
              <div className="grid grid-cols-2 gap-4">
                <p><strong>Reference Type:</strong> {application.referenceDetails.referenceType}</p>
                <p><strong>Recruiter Name:</strong> {application.referenceDetails.recruiterName}</p>
                <p><strong>Recruiter ID:</strong> {application.referenceDetails.recruiterId}</p>
              </div>
            </Card>
          )}

          {/* Professional Info */}
          {application?.professionalInfo && (
            <Card title="Professional Information">
              <div className="grid grid-cols-2 gap-4">
                <p><strong>Experience Type:</strong> {application.professionalInfo.experienceType}</p>
                <p><strong>Total Experience:</strong> {application.professionalInfo.totalExperience} Years</p>
                <p><strong>Previous Company:</strong> {application.professionalInfo.previousCompany}</p>
                <p><strong>Process:</strong> {application.professionalInfo.process}</p>
                <p><strong>Current CTC:</strong> {application.professionalInfo.currentCTC}k</p>
                <p><strong>Reason for Leaving:</strong> {application.professionalInfo.reasonForLeaving}</p>
              </div>
            </Card>
          )}

                    {/* Document Section */}
          <Card title="Documents">
            <div className="flex gap-4">
              {application?.documents?.resume?.link && (
                <button onClick={() => openModal(application.documents.resume.link)} className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700">
                  View Resume
                </button>
              )}
              {application?.documents?.aadharCard?.link && (
                <button onClick={() => openModal(application.documents.aadharCard.link)} className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700">
                  View Aadhar Card
                </button>
              )}
            </div>
          </Card>

          {/* Modal */}
          {showModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-80 backdrop-blur-sm">
              <div className="bg-white rounded-lg shadow-lg p-6 max-w-3xl w-full">
                <h2 className="text-xl font-semibold mb-4">Document Preview</h2>

                {documentLink.endsWith(".pdf") ? (
                  <iframe src={documentLink} className="w-full h-[500px] rounded-lg" title="PDF Preview" />
                ) : documentLink.endsWith(".docx") || documentLink.endsWith(".xlsx") ? (
                  <iframe src={`https://docs.google.com/gview?url=${documentLink}&embedded=true`} className="w-full h-[500px] rounded-lg" title="Google Docs Viewer" />
                ) : (
                  <img src={documentLink} alt="Document Preview" className="w-full max-h-[500px] object-contain rounded-lg" />
                )}

                <div className="mt-6 flex justify-end gap-4">
                  <a href={documentLink} target="_blank" rel="noreferrer" download className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
                    Download
                  </a>
                  <button onClick={closeModal} className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600">
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}


          {/* Offer Details */}
          {application?.offerDetails && (
            <Card title="Offer Details">
              <div className="grid grid-cols-2 gap-4">
                <p><strong>Joining Date:</strong> {new Date(application.offerDetails.joiningDate?.$date).toLocaleDateString()}</p>
                <p><strong>Offered CTC:</strong> {application.offerDetails.offeredCTC} LPA</p>
                <p><strong>Joining Mail Sent:</strong> {application.offerDetails.joiningMail?.status ? "Yes" : "No"}</p>
              </div>
            </Card>
          )}
        </div>
      </Container>
    </Layout>
  );
};

export default ApplicationDetails;